import type {
  JobHazardAnalysisStepResponse,
  RiskAssessmentCodeResponse,
} from 'src/api/ProactApiClient';
import {JobHazardAnalysisStateEnum} from 'src/api/ProactApiClient';
import type {PillProps} from 'src/design/atoms/Pill';
import type {ISelectOption} from 'src/types/Form';

export const pageTitleDict = {
  singular: 'Job Hazard Analysis',
  plural: 'Job Hazard Analyses',
};

export const initialJhanalysisData = {
  preparedBy: '',
  department: '',
  location: '',
  riskAssessmentCode: 0,
  workStartDate: '',
  workFinishDate: '',
  subjectName: '',
  approver: '',
  safetyReview: '',
};

export const jobStepsMeta: JobHazardAnalysisStepResponse = {
  name: '',
  potentialHazard: '',
  racBeforeControls: 0,
  safetyControls: [{id: 0, safetyControlsTitle: '', safetyNotes: ''}],
  racAfterControls: 0,
  jobHazardAnalysisId: 0,
  riskAfterProbability: 0,
  riskAfterSeverity: 0,
  riskBeforeProbability: 0,
  riskBeforeSeverity: 0,
  id: 0,
  percentOfOverallWork: 0,
  racMatrix: 0,
};

export const getRiskColor = (
  riskMatrix?: RiskAssessmentCodeResponse,
  racValue?: number
) => {
  if (!racValue || !riskMatrix) {
    return 'white';
  }

  if (racValue <= riskMatrix.lowMaxRange) {
    return 'green';
  }
  if (racValue <= riskMatrix.midMaxRange) {
    return 'yellow';
  }
  if (racValue <= riskMatrix.highMaxRange) {
    return 'red';
  }
  return 'white';
};

export const getRiskLabel = (
  riskMatrix?: RiskAssessmentCodeResponse,
  racValue?: number
): string => {
  if (!racValue || !riskMatrix) {
    return '—';
  }
  if (racValue <= riskMatrix.lowMaxRange) {
    return 'Low';
  }
  if (racValue <= riskMatrix.midMaxRange) {
    return 'Mid';
  }
  if (racValue <= riskMatrix.highMaxRange) {
    return 'High';
  }
  return '—';
};

export const safetyOptions = [
  'Elimination',
  'Substitution',
  'Isolation',
  'Engineering',
  'Administration',
  'PPE',
];

export const safetySelectOptions: ISelectOption[] = [
  {id: 1, label: 'Elimination'},
  {id: 2, label: 'Substitution'},
  {id: 3, label: 'Isolation'},
  {id: 4, label: 'Engineering'},
  {id: 5, label: 'Administration'},
  {id: 6, label: 'PPE'},
];

export const JobHazardAnalysisPillConfig = (
  state?: JobHazardAnalysisStateEnum
): PillProps[] => {
  switch (state) {
    case JobHazardAnalysisStateEnum.Draft:
      return [{text: 'Draft', color: 'gray'}];
    case JobHazardAnalysisStateEnum.PendingManagerReview:
      return [{text: 'Pending Manager Review', color: 'yellow'}];
    case JobHazardAnalysisStateEnum.PendingSafetyReview:
      return [{text: 'Pending Safety Review', color: 'yellow'}];
    case JobHazardAnalysisStateEnum.Approved:
      return [{text: 'Approved', color: 'green'}];
    default:
      break;
  }
  return [];
};

export const jhaDocumentTitle = 'JHA';
